module.exports = __webpack_public_path__ + "static/Very Good Security-825b5f2036d74a62d2a0d7ce90931b9f.jpg";